import React from 'react'
import styled from 'styled-components'
import {Skeleton} from '@mui/material'
import skeletonStyles from './skeleton.styles'

interface SkeletomAtomProps {
  ap_type:
    | 'app_footer_skeleton'
    | 'brand_app_bar_skeleton'
    | 'brand_app_content_area_skeleton'
    | 'login_header_skeleton'
    | 'login_form_skeleton'
    | 'order_details_skeleton'
    | 'visit_card_skeleton'
    | 'best_date_skeleton'
    | 'edit_location_address_skeleton'
}

const apAtomName = {ap_atom_name: 'apSkeletonAtom'}

const StyledWrapper = styled(props => <div {...props} />)`
  ${skeletonStyles}
`

const FooterSkeletonAtom: React.FC<SkeletomAtomProps> = function (props) {
  return (
    <StyledWrapper {...apAtomName} {...props}>
      <div>
        <Skeleton animation="wave" />
        <Skeleton animation="wave" />
        <Skeleton animation="wave" />
      </div>
      <div>
        <Skeleton animation="wave" />
        <Skeleton animation="wave" />
      </div>
      <div>
        <Skeleton animation="wave" />
      </div>
    </StyledWrapper>
  )
}

const BrandSkeletonAtom: React.FC<SkeletomAtomProps> = function (props) {
  return (
    <StyledWrapper {...apAtomName} {...props}>
      <Skeleton variant="rectangular" animation="wave" />
    </StyledWrapper>
  )
}

const LoginHeaderSkeleton: React.FC<SkeletomAtomProps> = function (props) {
  return (
    <StyledWrapper {...apAtomName} {...props}>
      <Skeleton animation="wave" />
      <div>
        <Skeleton animation="wave" />
      </div>
    </StyledWrapper>
  )
}

const LoginFormSkeleton: React.FC<SkeletomAtomProps> = function (props) {
  return (
    <StyledWrapper {...apAtomName} {...props}>
      <Skeleton animation="wave" />
    </StyledWrapper>
  )
}

const OrderDetailsSkeletonAtom: React.FC<SkeletomAtomProps> = function (props) {
  return (
    <StyledWrapper {...apAtomName} {...props}>
      <Skeleton animation="wave" />
      <Skeleton animation="wave" />
      <Skeleton animation="wave" />
      <Skeleton animation="wave" />
    </StyledWrapper>
  )
}

const VisitCardSkeletonAtom: React.FC<SkeletomAtomProps> = function (props) {
  return (
    <StyledWrapper {...apAtomName} {...props}>
      <Skeleton animation="wave" />
      <Skeleton animation="wave" />
    </StyledWrapper>
  )
}

const BestDateSkeletomAtom: React.FC<SkeletomAtomProps> = function (props) {
  return (
    <StyledWrapper {...props} {...apAtomName}>
      <Skeleton animation="wave" />
    </StyledWrapper>
  )
}

const EditLocationAddressSkeletonAtom: React.FC<SkeletomAtomProps> = function (
  props,
) {
  return (
    <StyledWrapper {...props} {...apAtomName}>
      <Skeleton animation="wave" />
      <Skeleton animation="wave" />
    </StyledWrapper>
  )
}

const SkeletonAtom: React.FC<SkeletomAtomProps> = function ({ap_type}) {
  switch (ap_type) {
    case 'app_footer_skeleton':
      return <FooterSkeletonAtom ap_type={ap_type} />
    case 'brand_app_bar_skeleton':
    case 'brand_app_content_area_skeleton':
      return <BrandSkeletonAtom ap_type={ap_type} />
    case 'login_header_skeleton':
      return <LoginHeaderSkeleton ap_type={ap_type} />
    case 'login_form_skeleton':
      return <LoginFormSkeleton ap_type={ap_type} />
    case 'order_details_skeleton':
      return <OrderDetailsSkeletonAtom ap_type={ap_type} />
    case 'visit_card_skeleton':
      return <VisitCardSkeletonAtom ap_type={ap_type} />
    case 'best_date_skeleton':
      return <BestDateSkeletomAtom ap_type={ap_type} />
    case 'edit_location_address_skeleton':
      return <EditLocationAddressSkeletonAtom ap_type={ap_type} />
    default:
      return null
  }
}

export default SkeletonAtom
